import React from "react";
import Layout from "../layouts/index.jsx";
import Header from "../layouts/header";
import PageTitleContainer from "../containers/global/page-title/index.jsx";
import Footer from "../layouts/footer";
import AboutContainer from "../containers/about";

import MedicalFeatureContainer from "../containers/home/medical-feature";

import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import SeoData from "../data/seo.json";

const AboutPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO {...SeoData["/about"]} pathname="/about" />
                <div className="wrapper">
                    <Header />
                    <div className="main-content site-wrapper-reveal">
                        <PageTitleContainer image="img/photos/about-bg1.jpg" subTitle="정환교 피부과 의원" title="병원 <span>소개</span>" />
                        <AboutContainer />

                        <MedicalFeatureContainer />

                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default AboutPage;
